import { render, staticRenderFns } from "./CAxAFFxMuscularSymptomsPage.vue?vue&type=template&id=2600dc6f"
import script from "./CAxAFFxMuscularSymptomsPage.vue?vue&type=script&lang=js"
export * from "./CAxAFFxMuscularSymptomsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports